import { useSignal, themeParams } from '@tma.js/sdk-react'
import { getPageContainerStyles } from '../../utils/safeArea'

interface LoadingProps {
  message?: string
  fullScreen?: boolean
  size?: 'sm' | 'md' | 'lg'
}

const sizeClasses = {
  sm: 'text-base py-5',
  md: 'text-lg py-10',
  lg: 'text-xl py-20',
}

/**
 * Reusable loading component with consistent styling
 * 
 * @example
 * <Loading message="Loading trainings..." />
 * <Loading fullScreen size="lg" />
 */
export function Loading({ message = 'Loading...', fullScreen = false, size = 'md' }: LoadingProps) {
  const bgColor = useSignal(themeParams.bgColor)
  const textColor = useSignal(themeParams.textColor)

  const content = (
    <div className={`text-center opacity-70 ${sizeClasses[size]}`}>
      <div className="text-4xl mb-3 animate-pulse">⏳</div>
      <div>{message}</div>
    </div>
  )

  if (fullScreen) {
    return (
      <div
        className="min-h-screen flex items-center justify-center"
        style={getPageContainerStyles(bgColor || '#ffffff', textColor || '#000000')}
      >
        {content}
      </div>
    )
  }

  return content
}
